import { useEffect, useState } from "react";
import { api, OFFICIAL_BOOKING_URL } from "@/lib/data";
import SectionTitle from "@/components/SectionTitle";
import RotatingVideo from "@/components/RotatingVideo";
import { HERO_VIDEOS } from "@/lib/videos";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Offers() {
    const [offers, setOffers] = useState([]);
    useEffect(() => { api.get("/offers").then(({ data }) => setOffers(data)).catch(() => {}); }, []);
    return (
        <div data-testid="offers-page">
            <RotatingVideo
                videos={HERO_VIDEOS}
                eager
                testId="offers-page-video"
                className="relative w-full h-[92vh] min-h-[640px]"
                overlay={
                    <>
                        <div className="absolute inset-0 bg-gradient-to-t from-navy/75 via-navy/20 to-navy/40" />
                        <div className="absolute inset-0 max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-end pb-16 md:pb-24">
                            <div className="text-[11px] uppercase tracking-[0.28em] text-gold mb-4 flex items-center gap-3"><span className="w-10 h-[1px] bg-gold" /> Offers</div>
                            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-ivory max-w-3xl leading-[1.02]">Curated <span className="font-serif-italic text-gold">seasonal packages</span>.</h1>
                            <p className="mt-6 text-ivory/85 max-w-xl leading-relaxed">Slow stays, honeymoons and wellness weeks — quietly generous, thoughtfully designed.</p>
                            <div className="mt-8 flex items-center gap-3">
                                <Link to="/booking" className="btn-gold px-6 py-3 rounded-full">Book Your Stay</Link>
                                <a href="#offers-list" className="btn-outline-ivory px-6 py-3 rounded-full">Learn More</a>
                            </div>
                        </div>
                    </>
                }
            />
            <div id="offers-list" className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-32 space-y-16">
                {offers.map((o, i) => (
                    <article key={o.id} data-testid={`offer-row-${o.slug}`} className={`grid md:grid-cols-5 gap-10 items-center ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}>
                        <div className="md:col-span-3 rounded-2xl overflow-hidden aspect-[16/10]">
                            <img src={o.image} alt={o.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" />
                        </div>
                        <div className="md:col-span-2">
                            <div className="text-[10px] uppercase tracking-[0.24em] text-gold">{o.nights} nights</div>
                            <h2 className="font-display text-4xl md:text-5xl text-navy mt-3">{o.title}</h2>
                            <p className="font-serif-italic text-jade text-xl mt-2">{o.subtitle}</p>
                            <p className="mt-4 text-navy/70 leading-relaxed">{o.description}</p>
                            <ul className="mt-6 space-y-2">
                                {o.perks.map((p) => (<li key={p} className="flex items-start gap-3 text-sm text-navy/80"><Check size={16} className="text-gold mt-0.5" /> {p}</li>))}
                            </ul>
                            <div className="mt-6 flex items-center justify-between flex-wrap gap-4">
                                <div><span className="text-navy/50 text-xs uppercase tracking-[0.18em]">From</span> <span className="font-display text-gold text-3xl ml-1">${o.price_from.toFixed(0)}</span></div>
                                <div className="flex items-center gap-2">
                                    <Link to="/contact" data-testid={`offer-page-learn-${o.slug}`} className="border border-navy text-navy px-5 py-2.5 rounded-full text-[11px] uppercase tracking-[0.16em] hover:bg-navy hover:text-ivory transition-colors">Learn More</Link>
                                    <Link to="/booking" data-testid={`offer-page-reserve-${o.slug}`} className="btn-gold px-5 py-2.5 rounded-full inline-flex items-center gap-2">Reserve Now <ArrowRight size={12} /></Link>
                                </div>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
